import { render, staticRenderFns } from "./QuickSMSForm.vue?vue&type=template&id=2cff7e9d&"
import script from "./QuickSMSForm.vue?vue&type=script&lang=js&"
export * from "./QuickSMSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports